import { Options } from './duplikit-options/duplikit-options-config';
import { IStrategyCustomMapping, IStrategySelections } from './master-identification-options/master-identification-options.component';
import { SelectedFields } from './report-field-options/report-field-options/selected-fields.model';
import { ICustomPairings, IEntityWeights } from './weight-table/weights-interfaces';

export class ScheduledDedupeSettingsCommand {
  corpId: number;
  enabledEntities: string;
  enabledDays: string;
  mergeTimeUTC: number;
  batchSize: number;
}

export class DuplikitSettings {
  options: Options;
  customStrategyMapping: IStrategyCustomMapping;
  strategy: IStrategySelections;
  scheduledDedupeSettings: ScheduledDedupeSettingsCommand;
  selectedFields: SelectedFields;
  weights: IEntityWeights;
  customWeightSelection: ICustomPairings;
  saveOutcomes;

  constructor(options: Options,
              customStrategyMapping: IStrategyCustomMapping,
              strategy: IStrategySelections,
              scheduledDedupeSettings: ScheduledDedupeSettingsCommand,
              selectedFields: SelectedFields,
              weights: IEntityWeights,
              customWeightSelection: ICustomPairings,
              saveOutcomes
  ) {

    this.options = options;
    this.customStrategyMapping = customStrategyMapping;
    this.strategy = strategy;
    this.scheduledDedupeSettings = scheduledDedupeSettings;
    this.selectedFields = selectedFields;
    this.weights = weights;
    this.customWeightSelection = customWeightSelection;
    this.saveOutcomes = saveOutcomes;
  }
}

export enum SaveOutcome {
  FULL_SYNC = 'FULL_SYNC',
  RUN_FINDER_SCRIPT = 'RUN_FINDER_SCRIPT',
  RUN_MASTER_ID_SCRIPT = 'RUN_MASTER_ID_SCRIPT',
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED'
}
